import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Milestone } from "./communicationTemplate.types";
// adjust path to where types live

type Props = {
  options: Milestone[];
  value: Milestone[];
  onChange: (value: Milestone[]) => void;
  placeholder?: string;
  className?: string;
};

const milestoneLabel = (o: Milestone) => o?.label || o?.milestone || "";

export default function MilestoneSelect({
  options,
  value,
  onChange,
  placeholder = "+ Add milestone",
  className,
}: Props) {
  return (
    <Autocomplete
      multiple
      className={className}
      options={options || []}
      value={value || []}
      onChange={(_e, newValue) => onChange(newValue as Milestone[])}
      getOptionLabel={milestoneLabel}
      isOptionEqualToValue={(opt, val) =>
        (opt._id || milestoneLabel(opt)) === (val._id || milestoneLabel(val))
      }
      disableCloseOnSelect
      fullWidth
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option._id || milestoneLabel(option)}>
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {milestoneLabel(option)}
        </li>
      )}
      sx={{ "& .MuiAutocomplete-tag": { margin: "2px" } }}
      // Render above the custom drawer (zIndex), always open downward,
      // and never flip upward when the control grows after a selection.
      slotProps={{
        popper: {
          sx: { zIndex: 20000 },
          placement: "bottom-start",
          modifiers: [
            { name: "flip", enabled: false },
            { name: "preventOverflow", enabled: false },
          ],
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={value?.length ? "" : placeholder}
        />
      )}
    />
  );
}